<template>
  <div
    class="hidden desktop:flex flex-row flex-wrap gap-2 absolute bottom-4 start-8 desktop:end-auto z-[1000] bg-transparent pointer-events-none max-w-[calc(100%-120px)] desktop:max-w-none"
  >
    <button
      v-for="status in statuses"
      :key="status.value"
      class="flex flex-row items-center gap-2 px-3 py-2 bg-white border-[1.5px] border-solid rounded-lg cursor-pointer pointer-events-auto shadow-[0px_2px_4px_0px_#0F151D33,0px_1px_10px_0px_#0000001F,0px_4px_5px_0px_#00000024] transition-opacity duration-200 hover:opacity-90"
      :class="{ 'bg-[#fff8ed]': selectedStatus === status.value }"
      :style="{
        '--status-color': status.color,
        borderColor: selectedStatus === status.value ? status.color : 'transparent',
      }"
      @click="handleStatusClick(status.value)"
    >
      <span
        class="w-3 h-3 rounded-full flex-shrink-0"
        :style="{ backgroundColor: status.color }"
      ></span>
      <span class="text-sm leading-5 text-[#0d0f15] whitespace-nowrap">{{ status.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { nameToColorPropertyMap } from '~/helpers/properties';

const props = defineProps<{
  selectedStatus?: string | null;
}>();

const emit = defineEmits<{
  (e: 'update:selected-status', status: string | null): void;
}>();

const { t } = useI18n();

// `value` stays the raw English status used for comparisons + the emitted
// filter value (Map.vue matches it against the untranslated dictionary
// display labels) — only `label` is localized for on-screen display.
const statuses = computed(() => [
  {
    value: 'Announcement',
    label: t('listings.mapStatusLegend.announcement'),
    color: nameToColorPropertyMap['Announcement'],
  },
  {
    value: 'Presale (EOI)',
    label: t('listings.mapStatusLegend.presaleEoi'),
    color: nameToColorPropertyMap['Presale (EOI)'],
  },
  { value: 'Launch', label: t('listings.mapStatusLegend.launch'), color: nameToColorPropertyMap['Launch'] },
  { value: 'On Sale', label: t('listings.mapStatusLegend.onSale'), color: nameToColorPropertyMap['On Sale'] },
]);

const handleStatusClick = (status: string) => {
  if (props.selectedStatus === status) {
    emit('update:selected-status', null);
  } else {
    emit('update:selected-status', status);
  }
};
</script>
